import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import HubNote from "employee/HubNote";
import ProfileIconButton from "employee/ProfileIconButton";
import { useDefaultToast, useErrorToast } from "lib/hooks/toasts";
import { usePost } from "redux/fetch-hooks";
import { Reaction } from "workstep/pages/Feedback/Comments/state/types";

import MessageCard from "./Panes/MessageCard";

type MessageData = {
    subject: string;
    body: string;
    logo: string | null;
    checkin_url: string | null;
};

type StateType = {
    messageData: MessageData;
};

type Props = {
    reaction?: Maybe<Reaction>;
    enableReactions?: boolean;
    showToast?: boolean;
};

export default function SMSLandingPageHub2({
    reaction,
    enableReactions = true,
    showToast = false,
}: Props) {
    const errorToast = useErrorToast();
    const defaultToast = useDefaultToast();
    const messageData = useSelector<StateType, MessageData>((state) => state.messageData);
    const urlParams = new URLSearchParams(window.location.search);
    const [reactionState, setReactionState] = useState(reaction);
    const [setReaction, { isLoading }] = usePost<{ reaction: Maybe<Reaction> }>(
        window.location.pathname,
        {
            onSuccess: (data) => {
                setReactionState(data.reaction);
                if (data.reaction) {
                    defaultToast(`Your ${data.reaction?.emoji} has been saved`, {
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                    });
                }
            },
            onError: () => {
                errorToast("There was an error saving your reaction");
            },
        },
    );
    useEffect(() => {
        if (showToast && reaction) {
            defaultToast(`Your ${reaction.emoji} has been saved`, {
                anchorOrigin: { vertical: "top", horizontal: "right" },
            });
        }
    }, []);

    const disableReactionSend = !!urlParams.get("d");
    const onReact = (val: Maybe<Reaction>) => {
        if (!disableReactionSend) {
            setReaction({ data: { reaction_type: val?.type || null } });
        }
    };
    return (
        <>
            <ProfileIconButton />
            <HubNote />
            <MessageCard
                subject={messageData.subject}
                body={messageData.body}
                checkinUrl={messageData.checkin_url}
                onReact={onReact}
                reactionLoading={isLoading}
                reaction={reactionState}
                enableReactions={enableReactions}
            />
        </>
    );
}
